module.exports = __webpack_public_path__ + "static/media/composeLayer.ed2d3f72.png";